<ng-form #form="ngForm">
  <account-edit-form-layout [source]="this"
    [sectionTitle]="'Personal details' | translate"
    [inFormTitle]="'Edit personal details' | translate">
    <!-- prefix -->
    <input-wrap class="block">
    <select class="input"
      name="prefix"
      autocomplete="honorific-prefix"
      [(ngModel)]="data.prefix"
      [muiInput]="'Title'| translate">
      @for (prefix of prefixes; track prefix) {
        <option
          [value]="prefix">
          {{prefix}}
        </option>
      }
    </select>
  </input-wrap>

  <!-- First & Last name -->
  <input-wrap class="m-t-6 m-t-9-s m-t-9-m block">
  <input class="input"
    type="text"
    name="firstname"
    autocomplete="given-name"
    [(ngModel)]="data.firstname"
    validatePattern="name"
    [muiInput]="'First name'| translate"
    maxlength="50"
    required
    firstname>
</input-wrap>

<input-wrap class="m-t-6 m-t-9-s m-t-9-m block">
<input class="input"
  type="text"
  name="lastname"
  autocomplete="family-name"
  [(ngModel)]="data.lastname"
  validatePattern="name"
  [muiInput]="'Last name'| translate"
  maxlength="50"
  required
  lastname>
</input-wrap>

</account-edit-form-layout>
</ng-form>